import { format } from "d3-format";
import React, { Component } from "react";
import PropTypes from "prop-types";

import displayValuesFor from "./displayValuesFor";
import GenericChartComponent from "../GenericChartComponent";

import ToolTipText from "./ToolTipText";
import ToolTipTSpanLabel from "./ToolTipTSpanLabel";
import { functor } from "../utils";

class AroonTooltip extends Component {
  constructor(props) {
    super(props);
    this.renderSVG = this.renderSVG.bind(this);
  }

  renderSVG(moreProps) {
    const {
      onClick,
      origin: originProp,
      className,
      fontFamily,
      fontSize,
      labelFill,
      textFill,
      displayFormat,
      yAccessor,
      options,
      appearance,
    } = this.props;

    const origin = functor(originProp);
    const {
      chartConfig: { width, height },
    } = moreProps;
    const [x, y] = origin(width, height);

    const currentItem = this.props.displayValuesFor(this.props, moreProps);
    const value = currentItem && yAccessor(currentItem);

    const aroonUpValue =
      value && Number.isFinite(value.aroonUp)
        ? displayFormat(value.aroonUp)
        : "n/a";
    const aroonDownValue =
      value && Number.isFinite(value.aroonDown)
        ? displayFormat(value.aroonDown)
        : "n/a";

    const period = options?.period;

    const upColor = appearance?.strokeAroonUp?.color || "#00DD00";
    const downColor = appearance?.strokeAroonDown?.color || "#FF0000";

    return (
      <g
        className={className}
        transform={`translate(${x}, ${y})`}
        onClick={onClick}
        data-evo-id="tooltip-aroon"
      >
        <ToolTipText
          fontFamily={fontFamily}
          fontSize={fontSize}
          fill={textFill}
        >
          <ToolTipTSpanLabel fill={labelFill}>Aroon</ToolTipTSpanLabel>
          <ToolTipTSpanLabel
            fill={labelFill}
          >{` (${period ?? "?"})`}</ToolTipTSpanLabel>
          <ToolTipTSpanLabel fill={labelFill}> Up: </ToolTipTSpanLabel>
          <tspan fill={upColor}>{aroonUpValue}</tspan>
          <ToolTipTSpanLabel fill={labelFill}> Down: </ToolTipTSpanLabel>
          <tspan fill={downColor}>{aroonDownValue}</tspan>
        </ToolTipText>
      </g>
    );
  }

  render() {
    return (
      <GenericChartComponent
        clip={false}
        svgDraw={this.renderSVG}
        drawOn={["mousemove"]}
      />
    );
  }
}

AroonTooltip.propTypes = {
  origin: PropTypes.oneOfType([PropTypes.array, PropTypes.func]),
  className: PropTypes.string,
  fontFamily: PropTypes.string,
  fontSize: PropTypes.number,
  labelFill: PropTypes.string,
  textFill: PropTypes.string,
  displayFormat: PropTypes.func,
  yAccessor: PropTypes.func.isRequired,
  options: PropTypes.object,
  appearance: PropTypes.object,
  displayValuesFor: PropTypes.func,
  onClick: PropTypes.func,
};

AroonTooltip.defaultProps = {
  origin: [0, 10],
  className: "react-stockcharts-tooltip react-stockcharts-aroon-tooltip",
  fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
  fontSize: 11,
  labelFill: "#4682B4",
  textFill: "#000000",
  displayFormat: format(".2f"),
  displayValuesFor,
  onClick: undefined,
};

export default AroonTooltip;
